import { Controller } from "@hotwired/stimulus"

// Feedback for the remote per-state ship speed <select> on the admin Ship
// Speed Defaults screen. rails-ujs performs the PUT; this controller shows
// pending/saved/failed status and reverts the select to the last persisted
// value when the server rejects the update, so the operator is never left
// looking at a value that was not actually saved.
export default class extends Controller {
  static targets = ["select", "status"]

  connect() {
    this.persistedValue = this.selectTarget.value
  }

  pending() {
    this.selectTarget.disabled = true
    this.showStatus("Saving…", "text-gray-500")
  }

  saved() {
    this.persistedValue = this.selectTarget.value
    this.selectTarget.disabled = false
    this.showStatus("Saved", "text-green-600")
    this.clearStatusLater()
  }

  failed() {
    this.selectTarget.value = this.persistedValue
    this.selectTarget.disabled = false
    this.showStatus("Save failed — reverted", "text-red-600")
  }

  showStatus(text, colorClass) {
    if (this.statusTimeout) clearTimeout(this.statusTimeout)
    this.statusTarget.textContent = text
    this.statusTarget.className = `ml-2 text-xs ${colorClass}`
  }

  clearStatusLater() {
    this.statusTimeout = setTimeout(() => {
      this.statusTarget.textContent = ""
    }, 2000)
  }
}
